<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .campaign-info-wrapper {
    display: flex;
    flex-direction: column;
    gap: utils.in_rem(4px);
  }

  .campaign-info {
    display: flex;
    align-items: center;
    gap: utils.in_rem(6px);
  }
</style>

<script>
  // Stores
  import { candidateStore } from "../stores";
  // Components
  import Link from "@sourcewhale/shared/svelte-design-system/components/atoms/Link.svelte";
  import PendingDot from "../../../elements/ProfileContactSideBarShared/PendingDot.svelte";
  import StatusDot from "../../../elements/ProfileContactSideBarShared/StatusDot.svelte";

  const campaignId = $derived($candidateStore?.campaignId);
  const campaignName = $derived($candidateStore?.campaignName);
  const candidateStatus = $derived($candidateStore?.status);
  const pendingCampaign = $derived($candidateStore?.pendingCampaign);
</script>

<div class="campaign-info-wrapper">
  {#if campaignId && campaignName}
    <div class="campaign-info">
      <StatusDot
        {candidateStatus}
        tooltip={`Active on campaign '${campaignName}'`}
      />
      <span
        >Active on <Link
          href="/campaign?campaignId={campaignId}"
          target="_blank"
          rel="noopener noreferrer">'{campaignName}'</Link
        ></span
      >
    </div>
  {/if}
  {#if pendingCampaign}
    <div class="campaign-info">
      <PendingDot campaignName={pendingCampaign.campaignName} />
      <span
        >Scheduled for <Link
          href="/campaign?campaignId={pendingCampaign.campaignId}"
          target="_blank"
          rel="noopener noreferrer">'{pendingCampaign.campaignName}'</Link
        ></span
      >
    </div>
  {/if}
</div>
